import firebase from '../constants/firebase';

const getUserIdByEmail = firebase.functions().httpsCallable('getUserIdByEmail');
const removeWriteAccessById = firebase
  .functions()
  .httpsCallable('removeWriteAccessById');

export const addEmailToMatrix = async (matrixId, email, userId) => {
  const result = await getUserIdByEmail({ matrixId, email, userId });
  return result;
};

export const removeEmailFromMatrix = async (
  matrixId,
  userId,
  userIdToRemove
) => {
  const result = await removeWriteAccessById({
    matrixId,
    userId,
    userIdToRemove,
  });
  return result;
};

export const get = async (id, requestingUser, requestingUserData = {}) => {
  if (!(requestingUser.claims.user_id === id || requestingUserData.isAdmin)) {
    return;
  }
  const db = firebase.firestore();

  const ref = await db.collection('users').doc(id);
  const snapshot = await ref.get();
  const data = await snapshot.data();
  return data;
};

export const save = async (
  id,
  userData,
  requestingUser,
  requestingUserData
) => {
  const db = firebase.firestore();
  const doc = await db.collection('users').doc(id);
  doc.set(userData);
};
